<template>
  <q-dialog :value="value" @input="$emit('input', $event)">
    <q-card style="min-width: 900px; max-width: 1200px">
      <q-card-section class="row items-center q-pb-none bg-red text-white">
        <div class="text-h6">규제별 정량값 판단 기준 매뉴얼</div>
        <q-space />
        <q-btn icon="close" flat round dense v-close-popup class="text-white" />
      </q-card-section>

      <q-card-section
        class="q-pa-md"
        style="max-height: 80vh; overflow-y: auto"
      >
        <div class="q-mb-sm text-caption text-grey-8">
          ※ <b>규제 판단 기준</b> 컬럼을 기준으로 입력해야 할 항목이 결정됩니다.
        </div>

        <q-markup-table
          flat
          bordered
          separator="cell"
          dense
          class="text-caption"
        >
          <thead class="bg-grey-3 text-weight-bold">
            <tr>
              <th class="text-center" style="width: 15%">법령</th>
              <th class="text-center" style="width: 35%">규제 항목</th>
              <th class="text-center" style="width: 15%">규제 판단 기준</th>
              <th class="text-center" style="width: 35%">입력 항목</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td rowspan="3" class="text-center text-weight-bold bg-blue-1">
                산업안전보건법
              </td>
              <td>
                제조금지물질 / 허가대상유해물질<br />
                관리대상유해물질 / 작업환경측정대상<br />
                특수건강진단대상 / 특별관리물질
              </td>
              <td class="text-center text-primary text-weight-bold">정량값</td>
              <td>
                <div>부등호</div>
                <div>정량값 (함유량)</div>
                <div>단위</div>
              </td>
            </tr>
            <tr>
              <td>노출기준설정물질 / 허용기준설정물질</td>
              <td class="text-center text-primary text-weight-bold">
                STEL, TWA
              </td>
              <td>
                <div>TWA (ppm, mg/㎥)</div>
                <div>STEL (ppm, mg/㎥)</div>
              </td>
            </tr>
            <tr>
              <td>PSM제출대상물질</td>
              <td class="text-center text-primary text-weight-bold">
                규정수량
              </td>
              <td>
                <div>규정수량</div>
                <div>단위</div>
              </td>
            </tr>
            <tr>
              <td rowspan="4" class="text-center text-weight-bold bg-orange-1">
                화학물질관리법
              </td>
              <td>기존화학물질 / 중점관리물질</td>
              <td class="text-center text-grey-6">단순 지정</td>
              <td class="text-grey-6">입력 항목 없음</td>
            </tr>
            <tr>
              <td>제한물질 / 금지물질</td>
              <td class="text-center text-primary text-weight-bold">정량값</td>
              <td>
                <div>부등호</div>
                <div>정량값</div>
                <div>단위</div>
              </td>
            </tr>
            <tr>
              <td>사고대비물질 / 인체급성·만성·생태유해성물질</td>
              <td class="text-center text-primary text-weight-bold">
                규정수량, 함유량
              </td>
              <td>
                <div>함유량 (%)</div>
                <div>규정수량</div>
              </td>
            </tr>
            <tr>
              <td>배출량조사대상 (PRTR 1, 2그룹)</td>
              <td class="text-center text-primary text-weight-bold">
                취급량, 함유량
              </td>
              <td>
                <div>함유량 (%)</div>
                <div>취급량 (톤/년)</div>
              </td>
            </tr>
            <tr>
              <td class="text-center text-weight-bold bg-red-1">
                위험물안전관리법
              </td>
              <td>제1류 ~ 제6류 위험물</td>
              <td class="text-center text-primary text-weight-bold">
                사업장 총 허가배수
              </td>
              <td>
                <div>지정수량</div>
                <div class="text-weight-bold text-red">
                  사업장 총 허가배수는 직접 확인 필요
                </div>
              </td>
            </tr>
            <tr v-for="law in simpleLaws" :key="law.name">
              <td class="text-center text-weight-bold" :class="law.bgColor">
                {{ law.name }}
              </td>
              <td v-html="law.items"></td>
              <td class="text-center text-grey-6">단순 지정</td>
              <td class="text-grey-6">입력 항목 없음</td>
            </tr>
            <tr>
              <td class="text-center text-weight-bold bg-green-1">
                폐기물관리법
              </td>
              <td>폐유기용제 / 지정폐기물</td>
              <td class="text-center text-primary text-weight-bold">정량값</td>
              <td>
                <div>부등호</div>
                <div>정량값</div>
                <div>단위</div>
              </td>
            </tr>
          </tbody>
        </q-markup-table>
      </q-card-section>

      <q-card-actions align="right" class="bg-grey-1">
        <q-btn flat label="닫기" color="primary" v-close-popup />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
export default {
  name: "chemUpdateManualDialog",
  props: {
    value: { type: Boolean, default: false },
  },
  data() {
    return {
      simpleLaws: [
        {
          name: "고압가스안전관리법",
          items: "특수고압가스 / 가연성가스<br>특정고압가스 / 독성가스",
          bgColor: "bg-purple-1",
        },
        {
          name: "대기환경보전법",
          items: "대기오염물질 / 특정대기유해물질<br>휘발성유기화합물 등",
          bgColor: "bg-teal-1",
        },
        {
          name: "물환경보전법",
          items: "수질오염물질 / 특정수질유해물질",
          bgColor: "bg-cyan-1",
        },
        {
          name: "토양환경보전법",
          items: "토양오염물질",
          bgColor: "bg-brown-1",
        },
        { name: "악취방지법", items: "지정악취물질", bgColor: "bg-grey-4" },
        {
          name: "오존층보호법",
          items: "오존층보호를 위한 특정물질",
          bgColor: "bg-indigo-1",
        },
        {
          name: "환경보건법",
          items: "위해성평가 대상 환경유해인자",
          bgColor: "bg-lime-1",
        },
      ],
    };
  },
};
</script>
